import React, { FC, useState } from 'react';
import { useDarkly } from 'integrations/launchDarkly/legacy/useDarkly';
import { JobFamilyGroupModel } from '@utmost.co/enterprise-models';
import { DataTableRowActions, DataTableRowAction } from '@utmost.co/utmost-design-system';
import { tokens } from '@beeline.com/bp-design-system';
import { useStaticPermission } from '../../../../../common/auth/Authorize';
import { JobFamilyGroupDialog } from './JobFamilyGroupDialog';
import { useDisabledJobFamilyGroupFields } from './useDisabledJobFamilyGroupFields';
import { useGetAllJobFamilyGroupData } from './useGetAllJobFamilyGroupData';
import { useJobFamilyGroupsIntl } from './translations/useJobFamilyGroupsIntl';

interface Props {
  jobFamilyGroup: JobFamilyGroupModel;
  onUpdated: (uid: string) => void;
  onDeleteAll: (uids: string[]) => void;
}

export const JobFamilyGroupActions: FC<React.PropsWithChildren<Props>> = ({
  jobFamilyGroup,
  onUpdated,
  onDeleteAll
}) => {
  const intl = useJobFamilyGroupsIntl();
  const [editJobFamilyGroup, showEditJobFamilyGroup] = useState(false);
  const { extendJobFamilyGroup } = useDarkly();
  const { gettingFullData } = useGetAllJobFamilyGroupData();
  const disabledFieldsResult = useDisabledJobFamilyGroupFields({ loading: gettingFullData, jobFamilyGroup });
  const familyPermissions = useStaticPermission('JOB_FAMILY_GROUP', true);

  return (
    <>
      {extendJobFamilyGroup && (familyPermissions.UPDATE || familyPermissions.DELETE) && (
        <DataTableRowActions disabled={disabledFieldsResult} dataTest="job-family-group-data-table-row-actions-button">
          <DataTableRowAction
            disabled={disabledFieldsResult || !familyPermissions.UPDATE}
            dataTest="job-family-group-table-overflow-edit-button"
            onClick={() => showEditJobFamilyGroup(true)}
          >
            {intl.edit}
          </DataTableRowAction>
          <DataTableRowAction
            disabled={disabledFieldsResult || !familyPermissions.DELETE}
            style={{ color: tokens.colorAlert }}
            dataTest="job-family-group-table-overflow-delete-button"
            onClick={() => onDeleteAll([jobFamilyGroup.uid])}
          >
            {intl.delete}
          </DataTableRowAction>
        </DataTableRowActions>
      )}
      {editJobFamilyGroup && (
        <JobFamilyGroupDialog
          jobFamilyGroup={jobFamilyGroup}
          onClose={() => showEditJobFamilyGroup(false)}
          onUpdated={() => {
            showEditJobFamilyGroup(false);
            onUpdated(jobFamilyGroup?.uid);
          }}
        />
      )}
    </>
  );
};
